var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "admin-content-area",
      attrs: { id: "page-content-wrapper" }
    },
    [
      _c("div", { staticClass: "container-fluid xyz" }, [
        _c("div", { staticClass: "page-header-top-container" }),
        _vm._v(" "),
        _c("div", { staticClass: "admin-page-content" }, [
          _c("div", { staticClass: "middle-page-wrap" }, [
            _c("h1", { staticClass: "page-title" }, [_vm._v(" Dashboard ")]),
            _vm._v(" "),
            _c("div", { staticClass: "dashboard-block col-12" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "row" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3"
                    },
                    [
                      _c("div", { staticClass: "dashboard-internal-box" }, [
                        _c(
                          "div",
                          { staticClass: "block-content-main" },
                          [
                            _vm._m(0),
                            _vm._v(" "),
                            _c("div", { staticClass: "right-block-content" }, [
                              _c("h5", [_vm._v(" Profile Info ")]),
                              _vm._v(" "),
                              _c("h6", [
                                _vm._v(
                                  " " + _vm._s(_vm.loginCustomerName) + " "
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "p",
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.loginCustomerAddressLine1) +
                                      " \n                                                    "
                                  ),
                                  _vm.loginCustomerAddressLine2 != ""
                                    ? [
                                        _vm._v(
                                          "\n                                                        " +
                                            _vm._s(
                                              _vm.loginCustomerAddressLine2
                                            ) +
                                            "\n                                                    "
                                        )
                                      ]
                                    : _vm._e(),
                                  _vm._v(
                                    "\n                                                     " +
                                      _vm._s(_vm.loginCustomerZipCode) +
                                      "\n                                                "
                                  )
                                ],
                                2
                              )
                            ]),
                            _vm._v(" "),
                            !_vm.isUserLogin
                              ? [
                                  _c(
                                    "div",
                                    { staticClass: "block-common-btn" },
                                    [
                                      _c(
                                        "router-link",
                                        {
                                          attrs: {
                                            to: { name: "CustomerProfile" }
                                          }
                                        },
                                        [
                                          _vm._v(" Manage User Profile "),
                                          _c("span", [
                                            _c("img", {
                                              attrs: {
                                                src:
                                                  "/static/images/right-arrow-img.png",
                                                alt: "Right Arrow"
                                              }
                                            })
                                          ])
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              : _vm._e()
                          ],
                          2
                        )
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3"
                    },
                    [
                      _c("div", { staticClass: "dashboard-internal-box" }, [
                        _c("div", { staticClass: "block-content-main" }, [
                          _vm._m(1),
                          _vm._v(" "),
                          _vm._m(2),
                          _vm._v(" "),
                          _c("div", { staticClass: "block-common-btn" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.goToOrderListWithOutFilters()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " View Orders \n\t\t\t\t\t\t\t\t\t\t\t        "
                                ),
                                _vm._m(3)
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3"
                    },
                    [
                      _c("div", { staticClass: "dashboard-internal-box" }, [
                        _c("div", { staticClass: "block-content-main" }, [
                          _vm._m(4),
                          _vm._v(" "),
                          _vm._m(5),
                          _vm._v(" "),
                          _c("div", { staticClass: "block-common-btn" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.goToConsignedInventoryList()
                                  }
                                }
                              },
                              [_vm._v(" View Inventory List "), _vm._m(6)]
                            )
                          ])
                        ])
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass:
                        "dashboard-internal-block col-12 col-sm-3 col-md-3 col-lg-3 col-xl-3"
                    },
                    [
                      _c("div", { staticClass: "dashboard-internal-box" }, [
                        _c("div", { staticClass: "block-content-main" }, [
                          _vm._m(7),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _c("div", { staticClass: "block-common-btn" }, [
                            _c(
                              "a",
                              {
                                attrs: { href: "javascript:void(0)" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.goToAuditInventoryList()
                                  }
                                }
                              },
                              [
                                _vm._v(
                                  " View Audit Inventory \n\t\t\t\t\t\t\t\t\t\t\t        "
                                ),
                                _vm._m(9)
                              ]
                            )
                          ])
                        ])
                      ])
                    ]
                  )
                ])
              ])
            ])
          ])
        ])
      ]),
      _vm._v(" "),
      _c("customer-footer")
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "block-content-img" }, [
      _c("img", {
        attrs: { src: "/static/images/profile-info.png", alt: "Profile Info" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "block-content-img" }, [
      _c("img", {
        attrs: {
          src: "/static/images/my-order-cart-img.png",
          alt: "My Order Cart"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-block-content" }, [
      _c("h5", [_vm._v(" My Orders ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(" To view all the orders "),
        _c("br"),
        _vm._v(" please click on the button below: ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        attrs: { src: "/static/images/right-arrow-img.png", alt: "Right Arrow" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "block-content-img" }, [
      _c("img", {
        attrs: {
          src: "/static/images/invetory-list-img.png",
          alt: "Inventory List"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-block-content" }, [
      _c("h5", [_vm._v(" My Consigned Inventory List ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(" To view all the Consigned Inventory "),
        _c("br"),
        _vm._v(" List  please click on the button below: ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        attrs: { src: "/static/images/right-arrow-img.png", alt: "Right Arrow" }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "block-content-img" }, [
      _c("img", {
        attrs: {
          src: "/static/images/my-order-cart-img.png",
          alt: "My Order Cart"
        }
      })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "right-block-content" }, [
      _c("h5", [_vm._v(" Audit Inventory ")]),
      _vm._v(" "),
      _c("p", [
        _vm._v(" To view all the audit inventory "),
        _c("br"),
        _vm._v(" please click on the button below: ")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", [
      _c("img", {
        attrs: { src: "/static/images/right-arrow-img.png", alt: "Right Arrow" }
      })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-35ff0bf5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-35ff0bf5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Customer/CustomerDashboard.vue
// module id = null
// module chunks = 